import React, { Component } from 'react';
import Nprogress from 'nprogress';
import ReactPlaceholder from 'react-placeholder';
import 'nprogress/nprogress.css';

import 'react-placeholder/lib/reactPlaceholder.css';
import CircularProgress from 'components/CircularProgress';

export default function asyncComponent(importComponent) {
  let cachedComponent = null;

  class AsyncFunc extends Component {
    constructor(props) {
      super(props);
      this.state = {
        component: cachedComponent,
      };
    }

    // eslint-disable-next-line react/no-deprecated
    componentWillMount() {
      if (!cachedComponent) {
        Nprogress.start();
      }
    }

    componentWillUnmount() {
      this.mounted = false;
    }

    async componentDidMount() {
      this.mounted = true;
      if (cachedComponent) return;
      const { default: Component } = await importComponent();
      Nprogress.done();
      cachedComponent = Component;
      if (this.mounted) {
        this.setState({
          component: Component,
        });
      }
    }

    render() {
      const LoadedComponent = this.state.component;
      if (LoadedComponent) {
        return <LoadedComponent {...this.props} />;
      }
      return (
        <ReactPlaceholder type="text" rows={7} ready={true}>
          <CircularProgress />
        </ReactPlaceholder>
      );
    }
  }

  return AsyncFunc;
}
